import { FC } from 'react';
import { Typography } from '@mui/material';

import { TeamStanding } from '@/features/teams/types/TeamModel';
import { getOrdinalSuffix } from '@/shared/utils/getPeriodName';

// Season record under the team crest, either bare ("48-29-5") or with division
// placement ("48-29-5, 3rd in Pacific"). The game page scoreboard has room for
// the placement; the games list card does not, so GameCard opts out.
//
// Only NHL teams carry a `standing` today and it is null until the season's
// first standings pull, so callers gate on its presence rather than on the
// league. The placement clause is also dropped when the snapshot has no
// division, leaving the bare W-L-OTL.
const TeamRecord: FC<{
  standing: TeamStanding;
  align: 'left' | 'center' | 'right';
  showPlacement?: boolean;
}> = ({ standing, align, showPlacement = true }) => {
  const { wins, losses, overtimeLosses, divisionRank, divisionName } = standing;
  const placement =
    showPlacement && divisionRank && divisionName
      ? `, ${divisionRank}${getOrdinalSuffix(divisionRank)} in ${divisionName}`
      : '';

  return (
    <Typography
      sx={(theme) => ({
        color: theme.palette.cx.washDark[300],
        textAlign: align,
        fontFamily: 'Sohne',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px',
        letterSpacing: '0px',
      })}
    >
      {`${wins}-${losses}-${overtimeLosses}${placement}`}
    </Typography>
  );
};

export default TeamRecord;
